import {ON_CHANGE_SIDEBAR} from '../actions/types'

export const sideBarOnchangeActionFunction = ({ props, value }) => {

    return {
      type: ON_CHANGE_SIDEBAR,
      payload: { props, value },
    };
  };